import type {SocialLoginType} from "../../shared/types/common";
import {environment} from "../../infrastructure/config/environment";

/**
 * 소셜 로그인 창과 관련된 커스텀 훅
 */
export const useSocialLogin = () => {
    const login = (provider: SocialLoginType) => {
        switch (provider) {
            case "google":
                window.location.href = `${environment.apiBaseUrl}/auth/google?callbackUrl=https://${window.location.host}/auth/callback`;
                break;
            case "kakao":
                window.location.href = `${environment.apiBaseUrl}/auth/kakao?callbackUrl=https://${window.location.host}/auth/callback`;
                break;
            case "naver":
                window.location.href = `${environment.apiBaseUrl}/auth/naver?callbackUrl=https://${window.location.host}/auth/callback`;
                break;
        }
    };

    return {login};
}